// src/pages/SSS.jsx
import React, { useState } from "react";

const SSS = () => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (categoryIndex, itemIndex) => {
    setOpenItems(prev => ({
      ...prev,
      [`${categoryIndex}-${itemIndex}`]: !prev[`${categoryIndex}-${itemIndex}`]
    }));
  };

  const faqData = [
    {
      category: "Web Kurumsal Kullanıcı",
      items: [
        {
          question: "Kurumsal hesabımı nasıl oluşturabilirim?",
          answer: "Kurumsal üyelik için web sitemizde bulunan 'Kurumsal Üye Ol' bölümünden başvuru formunu doldurabilirsiniz. Başvurunuz incelendikten ve onaylandıktan sonra kurumsal portalınıza erişim sağlanacaktır."
        },
        {
          question: "Kurumsal portalda şirket bilgilerimi nasıl güncelleyebilirim?",
          answer: "Kurumsal giriş yaptıktan sonra açılan portal sayfasında şirket bilgileriniz görüntülenir. Her bir alanın üzerine tıklayarak bilgilerinizi güncelleyebilirsiniz. Güncellenen bilgiler anında sistemde görünür."
        },
        {
          question: "Kurumsal portalda şirket logosunu nasıl güncelleyebilirim?",
          answer: "Kurumsal giriş yaptıktan sonra portalda bulunan 'Logo Değiştir' butonuna tıklayarak logonuzu yükleyebilirsiniz. Logo tercihen beyaz arka plana sahip olmalıdır; yüksek çözünürlükte ve kurumsal kimliğinize uygun olması önerilir."
        },
        {
          question: "Projelerimde yaptığım değişiklikler onaya tabi midir?",
          answer: "Kurumsal üyelik kapsamında yapılan güncellemeler sistem tarafından otomatik olarak uygulanır. Ancak, güncellemeler şirketimizin Kullanım Koşulları, Aydınlatma Metni, Yasal Uyarı ve İlan Yayınlama Kuralları ile uyumlu olmalıdır. Uyumsuzluk tespit edilirse, şirketimiz söz konusu içerik üzerinde gerekli düzenlemeleri yapma hakkına sahiptir."
        },
        {
          question: "Projelerime eklediğim görsel ve dosyalarla ilgili sınırlamalar nelerdir?",
          answer: "Projelerinize yüklenen görseller ve dokümanlar en fazla 10 MB boyutunda olabilir. Dosya formatları JPEG, PNG, PDF veya DOCX olarak desteklenmektedir."
        }
      ]
    },
    {
      category: "Mobil Kullanıcı Anonim Kullanıcı",
      items: [
        {
          question: "Anonim kullanıcı olarak hangi işlemleri yapabilirim?",
          answer: "Anonim kullanıcılar, uygulamaya giriş yapmadan veya kayıt olmadan yalnızca projeleri, haberleri ve içerikleri görüntüleyebilir. Favori ekleme, yorum yazma, proje puanlama, haber değerlendirme, yapay zeka destekli ilçe karşılaştırma ve çark ödül sistemi gibi özellikler anonim kullanıcılara kapalıdır."
        },
        {
          question: "Anonim kullanıcıyken kayıt olmadan devam edebilir miyim?",
          answer: "Evet. Uygulamamızda 'Kayıt Olmadan Devam Et' seçeneği bulunmaktadır. Bu şekilde anonim olarak tüm görsel içeriklere erişebilir, ancak etkileşimli özellikleri kullanamazsınız."
        },
        {
          question: "Anonim kullanıcıyken favoriye proje ekleyebilir miyim?",
          answer: "Hayır. Favorilere proje eklemek, yorum yazmak, proje puanlamak ve yapay zeka analizlerini kullanmak için kayıt olmanız ve hesabınıza giriş yapmanız gerekmektedir."
        },
        {
          question: "Anonim kullanımdayken verilerim saklanır mı?",
          answer: "Anonim kullanımda herhangi bir kişisel veriniz toplanmaz. Sadece uygulama içi gezinme verileri, performans iyileştirmeleri için anonim olarak analiz edilebilir."
        }
      ]
    },
    {
      category: "Mobil Üye Kullanıcı",
      items: [
        {
          question: "Mobil uygulamaya nasıl üye olabilirim?",
          answer: "Mobil uygulama üzerinden e-posta, Apple veya Google hesabınızla kayıt olabilirsiniz. Kayıt sırasında belirlediğiniz şifre güvenlik kurallarına uygun olmalıdır. Kayıt sonrası e-posta doğrulaması yapmanız gerekmektedir."
        },
        {
          question: "Üye kullanıcılara özel hangi özellikler vardır?",
          answer: "Üye kullanıcılar; projelere yorum yapabilir, favori ekleyebilir, proje puanlayabilir, haber değerlendirebilir, yapay zeka destekli ilçe karşılaştırma özelliğini kullanabilir ve haftada 2 kez çark ödül sisteminden yararlanabilir."
        },
        {
          question: "Şifremi unuttum, ne yapmalıyım?",
          answer: "Mobil uygulamada 'Profil' ekranında bulunan 'Şifremi Unuttum' seçeneği ile yeni şifre oluşturabilirsiniz. Şifre sıfırlama bağlantısı e-posta adresinize gönderilecektir."
        },
        {
          question: "Profil bilgilerimi nasıl güncelleyebilirim?",
          answer: "Profil sayfanız üzerinden ad, soyad, profil fotoğrafı ve iletişim bilgilerinizi güncelleyebilirsiniz. Güncellemeler anında sistemde yansıtılır."
        },
        {
          question: "Hesabımı nasıl silebilirim?",
          answer: "Profil sayfasından hesap silme işlemi başlatılabilir. Hesabınızı silmek için şifrenizle doğrulama yapmanız gerekmektedir. Şifre doğrulaması tamamlanmadan hesap silme işlemi gerçekleşmez. Hesap silindikten sonra tüm verileriniz KVKK'ya uygun şekilde sistemden kaldırılır."
        },
        {
          question: "Çark ödül sisteminden nasıl yararlanabilirim?",
          answer: "Çark ödül sistemi yalnızca kayıtlı kullanıcılara açıktır. Haftada 2 kez çarkı çevirerek çeşitli ödüller kazanabilirsiniz. Ödül hakkınız kullanıcı bazında haftalık olarak yenilenir."
        }
      ]
    },
    {
      category: "Güvenlik ve Gizlilik",
      items: [
        {
          question: "Kişisel verilerim güvenli mi?",
          answer: "Evet. Tüm kullanıcı verileri KVKK ve GDPR standartlarına uygun olarak güvenli bir şekilde saklanmaktadır. Hiçbir kullanıcı verisi izinsiz paylaşılmaz, üçüncü taraflarla açık izin olmadan paylaşılmaz."
        },
        {
          question: "Hesap silme sonrası verilerim ne oluyor?",
          answer: "Hesap silme işlemi sonrası kişisel bilgileriniz sistemden tamamen ve kalıcı olarak silinir. Yasal yükümlülükler gereği saklanması gereken veriler dışında hiçbir veri tutulmaz."
        },
        {
          question: "Bildirim izinleri neden isteniyor?",
          answer: "Bildirim izinleri, size yeni projeler, güncellemeler ve fırsatlar hakkında anında bilgi verebilmek için talep edilir. Bildirim ayarlarını profil sayfanızdan istediğiniz zaman değiştirebilirsiniz."
        },
        {
          question: "Uygulama finansal işlem yapıyor mu?",
          answer: "Hayır. Uygulamamız yalnızca bilgilendirme ve analiz platformudur. Kesinlikle emlak danışmanlığı, finansal işlem veya yatırım tavsiyesi sunmaz."
        }
      ]
    },
    {
      category: "Destek",
      items: [
        {
          question: "Teknik destek talebimi nasıl iletebilirim?",
          answer: "Her türlü teknik veya kullanıcı deneyimi ile ilgili sorularınızı destek@temelden.com.tr adresine iletebilirsiniz. En kısa sürede dönüş yapılacaktır."
        },
        {
          question: "Hata bildiriminde bulunmak istiyorum, nasıl yapabilirim?",
          answer: "Uygulama içinde karşılaştığınız hataları aynı e-posta adresi üzerinden detaylı şekilde iletebilirsiniz. Hata raporunuz işleme alınır ve çözüm süreci hakkında bilgilendirilirsiniz."
        },
        {
          question: "Geri bildirim ve önerilerimi nereye iletebilirim?",
          answer: "Geri bildirim ve önerileriniz için yine destek@temelden.com.tr adresini kullanabilirsiniz. Tüm öneriler değerlendirmeye alınır ve uygulama güncellemelerinde dikkate alınır."
        },
        {
          question: "Yanıt süreniz nedir?",
          answer: "Talepleriniz en geç 2 iş günü içinde yanıtlanır. Acil durumlarda en kısa sürede dönüş sağlanmaya çalışılır."
        }
      ]
    }
  ];

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>SIKÇA SORULAN SORULAR</h1>

        <section style={styles.section}>
          <p style={styles.text}>
            Aşağıda platformumuz hakkında en çok sorulan soruları ve cevaplarını bulabilirsiniz. 
            Eğer aradığınız soruyu bulamazsanız, lütfen bizimle iletişime geçmekten çekinmeyin.
          </p>
        </section>

        <div style={styles.faqContainer}>
          {faqData.map((category, categoryIndex) => (
            <div key={categoryIndex} style={styles.category}>
              <h2 
                style={styles.categoryTitle}
                onClick={() => setActiveCategory(activeCategory === categoryIndex ? null : categoryIndex)}
              >
                {category.category}
                <span style={styles.arrow}>
                  {activeCategory === categoryIndex ? '▲' : '▼'}
                </span>
              </h2>
              
              {(activeCategory === categoryIndex || activeCategory === null) && (
                <div style={styles.faqItems}>
                  {category.items.map((item, itemIndex) => (
                    <div key={itemIndex} style={styles.faqItem}>
                      <div 
                        style={styles.question}
                        onClick={() => toggleItem(categoryIndex, itemIndex)}
                      >
                        <h3 style={styles.questionText}>{item.question}</h3>
                        <span style={styles.icon}>
                          {openItems[`${categoryIndex}-${itemIndex}`] ? '−' : '+'}
                        </span>
                      </div>
                      {openItems[`${categoryIndex}-${itemIndex}`] && (
                        <div style={styles.answer}>
                          {item.answer.split('\n').map((line, index) => (
                            <p key={index} style={styles.answerText}>{line}</p>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <section style={styles.contactSection}>
          <h2 style={styles.heading}>Cevabını Bulamadınız mı?</h2>
          <p style={styles.text}>
            Yukarıdaki sorular size yardımcı olmadıysa, lütfen bizimle iletişime geçin. 
            Size en kısa sürede dönüş yapacağız.
          </p>
          <div style={styles.contactButtons}>
            <a href="/iletisim" style={styles.contactButton}>
              İletişim Sayfasına Git
            </a>
            <a href="mailto:info@vondigital.com.tr" style={styles.contactButton}>
              E-posta Gönder
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "30px",
  },
  heading: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "15px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  faqContainer: {
    marginBottom: "40px",
  },
  category: {
    marginBottom: "20px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    overflow: "hidden",
  },
  categoryTitle: {
    backgroundColor: "#f8f9fa",
    padding: "15px 20px",
    margin: 0,
    fontSize: "16px",
    fontWeight: "600",
    color: "#0056b3",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "background-color 0.3s ease",
  },
  arrow: {
    fontSize: "12px",
    color: "#666",
  },
  faqItems: {
    backgroundColor: "#fff",
  },
  faqItem: {
    borderBottom: "1px solid #f0f0f0",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  question: {
    padding: "15px 20px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "background-color 0.3s ease",
  },
  questionText: {
    margin: 0,
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
    flex: 1,
  },
  icon: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#0056b3",
    marginLeft: "10px",
  },
  answer: {
    padding: "0 20px 15px 20px",
    backgroundColor: "#fafafa",
  },
  answerText: {
    margin: "8px 0",
    fontSize: "14px",
    color: "#555",
    lineHeight: "1.6",
  },
  contactSection: {
    backgroundColor: "#f8f9fa",
    padding: "25px",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
    textAlign: "center",
  },
  contactButtons: {
    display: "flex",
    gap: "15px",
    justifyContent: "center",
    marginTop: "20px",
  },
  contactButton: {
    backgroundColor: "#0056b3",
    color: "white",
    padding: "12px 24px",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "500",
    transition: "background-color 0.3s ease",
    textAlign: "center",
  },
};

// Hover efektleri
styles.categoryTitle = {
  ...styles.categoryTitle,
  ":hover": {
    backgroundColor: "#e9ecef",
  },
};

styles.question = {
  ...styles.question,
  ":hover": {
    backgroundColor: "#f8f9fa",
  },
};

styles.contactButton = {
  ...styles.contactButton,
  ":hover": {
    backgroundColor: "#004494",
  },
};

export default SSS;